import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchPositions = ({ accountId }) => get(`/accounts/${accountId}/positions`);

export const addPosition = ({ accountId, position }) => post(`/accounts/${accountId}/positions`, position);

export const deletePosition = ({ accountId, positionId }) =>
  httpDelete(`/accounts/${accountId}/positions/${positionId}`);

export const updatePosition = ({ accountId, positionId, position }) =>
  patch(`/accounts/${accountId}/positions/${positionId}`, position);
